module.exports = [{
      plugin: require('/Users/wangwanli/Documents/workspace/massnet.org/packages/desktop/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
